
















































































import Vue from 'vue'
import { mapState } from 'vuex'
import { TableHeader } from '@/utils/interfaces'
export default Vue.extend({
  props: {
    multiple: Boolean,
  },
  data() {
    return {
      state: this.$store.getters['remittance/data'],
      headers: [
        {
          text: this.$t('name'),
          value: 'subregion_name',
        },
        {
          text: this.$t('percent-commission') + ' (%)',
          value: 'percent_commission',
        },
        {
          text: this.$t('minimum-commission') + ' ($)',
          value: 'min_commission',
        },
      ] as TableHeader[],
    }
  },
  computed: {
    ...mapState('remittance', ['data']),
  },
  watch: {
    data(value) {
      this.state = value
    },
  },
})
